import api from './api';

export const networkService = {
  getNetworkCluster: () => api.getNetworkCluster(),
  getNetworkTree: (userId) => api.getNetworkTree(userId),
  createInvite: () => api.createInvite(),
  getNetworkStats: () => api.getNetworkStats(),
  mergeNetworkTrees: (targetUserId) => api.mergeNetworkTrees(targetUserId),
  mergeNetworkByCode: (inviteCode) => api.mergeNetworkByCode(inviteCode)
};

export default networkService;
